import { BrowserRouter as Router } from "react-router-dom";
import { AstroWrapper, NextGenTheme } from "@pingux/astro";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@assets/styles/global.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Router>
    <AstroWrapper theme={NextGenTheme}>
      <App />
    </AstroWrapper>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
